import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getUsers, UpdateUser, updateUniqueUser, addState } from '../../actions';
import api from '../../actions/api';
import moment from 'moment';
import ModalGerente from '../Modais/ModalGerente';
import ModalConfirm from '../Modais/ModalConfirm';
import { toastMessage } from '../../utils/Utils';
import { Lock } from 'react-feather';

class Usuarios extends Component {
    state = { 
        user: {},
        perPage: 20,
        campo: '', 
        nome: '',
        email: '',
        cpfcnpj: '',
        gerente: undefined,
        listaUsuario: [],
        loadGerente: false,
    }

    componentDidMount(){
        this.props.getUsers()
    }

    onSubmit(event){
        event.preventDefault()
        const { nome, email, cpfcnpj } = this.state
        this.props.getUsers(1, undefined,{ nome, email, cpfcnpj })
    }

    exibirGerente(id){
        this.setState({
            gerente: undefined, 
            listaUsuario: [],
            loadGerente: true,
        })
        api.get(`/user/manager/${id} `)
        .then(success=>{
            console.log('=> GERENTE - LISTA: ', success.data)

            this.setState({
                gerente: success.data.payload.gerente, 
                listaUsuario: success.data.payload.usuarios,
                loadGerente: false,
            })
        })
        .catch(error => {
            console.log('error', error)
        })  
    }

    salvarGerente = (gerenteId, usuariosGerenciadosIds, manipulaDocumento = 'N') => {
        api.post('/user/manager/', { gerenteId, usuariosGerenciadosIds, manipulaDocumento })
        .then(success=>{
            // console.log('=> GERENTE - SALVO: ', success.data)
            this.props.getUsers()
            toastMessage('success', 'Gerente salvo com sucesso!') 
        })
        .catch(error => {
            console.log('error', error)
        })  
    }

    removerGerente = (id) => {
        api.delete(`/user/manager/${id} `)
        .then(success=>{
            this.props.getUsers()
            toastMessage('success', 'Gerente removido com sucesso!') 
        })
        .catch(error => {
            console.log('error', error)
        })  
    }

    changeStatus = () => {
        var { user, campo } = this.state
        if(Object.keys(user).length > 0){ 

            user[campo] = user[campo] == 1 ? 0 : 1

            this.props.UpdateUser({ ...user,cpf: user.cpfcnpj }, async res => {
                await document.querySelector('#modalConfirm .close').click()

                if(res){
                    toastMessage('success', 'Atualizado com sucesso!') 
                    this.props.updateUniqueUser(user)
                }                 
                          
                  
            })
        }
         
    }

    qntLinks(){
        //calcula a qnd de link para paginação
        const { lastPage } = this.props.usuarios.paginate
        let qnt = Math.ceil(lastPage)

        qnt = qnt >= 1 ? qnt : 1//calculo para não quebrar página com valores de array invalidos

        var qntArray =  new Array(qnt).fill(1)

        return qntArray.map( (v,i) => {
            return (
                <li key={'link'+i} className="page-item"><a className="page-link" href="#" onClick={ () => this.pagination(i+1)}>{i+1}</a></li>
            )
        })
    }

    pagination(page){
        let { perPage } = this.state
        let { lastPage } = this.props.usuarios.paginate
        page = page < 1 ? 1 : page
        
        if(page <= lastPage && page > 0)
            this.props.getUsers(page,perPage);
    }
    
    action = (event) => {
        let value = event.target.value
        let name = event.target.name
        this.setState({ [name]:value })
    }

    render(){
        //console.log(this.props)
        const { loading_users, paginate } = this.props.usuarios
        const { loading_cadastro } = this.props.auth
        const { page, data } = paginate
        return(
            <>
                <div>
                    <h6 className="pb-2 mb-0">Filtros</h6>
                        <form onSubmit={ event => this.onSubmit(event)} className='border-bottom border-gray' style={{ marginBottom: 10, paddingTop: 10, paddingBottom: 10 }}>
                            <div style={{ display:'flex', flexWrap: 'wrap'}}>
                                <div className="form-group" style={{ marginRight: 8 }}>
                                    <span>Nome:</span>
                                    <input name="nome" type="text" value={this.state.nome} className="form-control" placeholder="Nome" onChange={(event) => this.action(event)} />
                                </div>
                                <div className="form-group" style={{ marginRight: 8 }}>
                                    <span>E-mail</span>
                                    <input name="email" type="text" value={this.state.email} className="form-control" placeholder="E-mail" onChange={(event) => this.action(event)} />
                                </div>
                                <div className="form-group" style={{ marginRight: 8 }}>
                                    <span>CPF</span>
                                    <input name="cpfcnpj" type="text" value={this.state.cpfcnpj} className="form-control" placeholder="CPF" onChange={(event) => this.action(event)} />
                                </div>
                            </div>
                            <button disabled={loading_users} className="btn my-2 my-sm-0 btn-primary" type="submit">Pesquisar</button>
                        </form>
                </div>
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center'}}>
                    <table className="table table-bordered" id="tableUsers">
                        <thead className="thead-dark">
                            <tr>
                                <th scope="col">Nome</th>
                                <th scope="col">CPF/CNPJ</th>
                                <th scope="col">E-mail</th>
                                <th scope="col">Status</th>
                                <th scope="col">Nivel Acesso</th>
                                <th scope="col">Gerente</th>
                                <th scope="col" colSpan="2">Ações</th>
                                {/* <th scope="col">Ação</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {!loading_users && data && data.map( (user, index) => {
                                const { nome, cpfcnpj, email, nivel_acesso, ativo, gerente } = user
                                return (
                                    <tr key={'user'+index}>
                                        <td>{nome}</td>
                                        <td>{cpfcnpj}</td>
                                        <td>{email}</td>
                                        <td style={{...styles.td,  color: ativo == 1 ? 'green' : 'red'}} onClick={() => this.setState({ user, campo: 'ativo' })} data-toggle="modal" data-target="#modalConfirm">
                                            {ativo == 1 ? 'Ativo' : 'Desativado'}
                                            <span 
                                                data-feather="refresh-ccw" style={styles.feather} 
                                                ></span>
                                        </td>
                                        <td style={{ ...styles.td, color: nivel_acesso == 1 ? '#007bff' : 'black'}} onClick={() => this.setState({ user, campo: 'nivel_acesso' })} data-toggle="modal" data-target="#modalConfirm">
                                            {nivel_acesso == 1 ? 'ADM' : 'Comum'}
                                            <span 
                                                data-feather="refresh-ccw" style={styles.feather} 
                                                ></span>
                                        </td>
                                        <td>{gerente ? 'Sim' : 'Não'}</td>
                                        <td onClick={() => this.props.addState({ userUpdate: user })}>
                                            {/* <span 
                                                data-feather="refresh-ccw" style={styles.feather} 
                                                onClick={() => this.setState({ user })}
                                                data-toggle="modal" data-target="#modalConfirm"
                                                ></span> */}
                                            <Lock style={styles.feather}  data-toggle="modal" data-target="#modalUpdatePassword"/>
                                        </td>
                                        <td><button className="btn btn-dark" data-toggle="modal" data-target="#modalGerente" onClick={() => this.exibirGerente(user.id)}>
                                            {gerente ? 'Editar Gerente' : 'Tornar Gerente'}</button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>

                    {loading_users && <div className="spinner-border" role="status" style={{margin:'5%'}}>
                        <span className="sr-only">Loading...</span>
                    </div>}

                    <nav aria-label="Page navigation example">
                        <ul className="pagination mt-3">
                            <li className="page-item">
                                <button className="page-link" aria-label="Previous" onClick={ () => this.pagination(page-1)}>
                                        <span aria-hidden="true">&laquo;</span>
                                        <span className="sr-only">Previous</span>
                                </button>
                            </li>
                            {
                                this.qntLinks(data.length)
                            }
                            
                            <li className="page-item">
                                <button className="page-link" aria-label="Next" onClick={ () => this.pagination(page+1)}>
                                        <span aria-hidden="true">&raquo;</span>
                                        <span className="sr-only" >Next</span>
                                </button>
                            </li>
                        </ul>
                    </nav>

                    <ModalConfirm load={loading_cadastro} title={'Atenção!'} accept={this.changeStatus} text={'Deseja realmente alterar o status deste usuário?'} />
                    <ModalGerente 
                        gerente={this.state.gerente} 
                        listaUsuario={this.state.listaUsuario} 
                        loadGerente={this.state.loadGerente} 
                        removerGerente={this.removerGerente}
                        salvarGerente={this.salvarGerente}
                        closeModal={() => this.modalGerente()}
                    />
                </div>
            </>
        )
    }
}

const styles = {
    feather: {
        width: '16px',
        height: '16px',
        verticalAlign: 'text-bottom',
        marginRight:6,
        cursor: 'pointer',
        marginLeft: 6,
        color: 'black'
    },
    td:{ 
        cursor: 'pointer', 
        // display:'flex', 
        // justifyContent:'space-between', 
        // alignItems:'center'
    }
}

const mapStateToProps = ({ usuarios, auth }) => {
    return {
        usuarios, auth
    }
}

export default connect(mapStateToProps, {
    getUsers, UpdateUser, updateUniqueUser, addState
})(Usuarios);